


const RecursiveTree = ({ htmlFn, data }) => {
    if (!data) return null;

    return (
        <div>
            <div>{htmlFn ? htmlFn(data) : null}</div>
            {data.children != null && data.children.length > 0 &&
                <div>
                    {data.children.map((item, index) => (
                        <div key={index} style={{paddingLeft: "10px"}}>
                            <RecursiveTree htmlFn={htmlFn} data={item} />
                        </div>
                    ))}
                </div>
            }
        </div>
    );
};

export default RecursiveTree;
